import { z } from 'zod';
import { BibleLocationSchema } from '../bible/bible-location.js';
/**
 * Citation from RAG retrieval.
 */
export const CitationSchema = z.object({
    reference: z.string(),
    text: z.string(),
    metadata: z.object({
        type: z.string(),
        location: BibleLocationSchema.optional(),
        source: z.string().optional(),
    }),
});
/**
 * Textual variant info in response.
 */
export const VariantInfoSchema = z.object({
    reference: z.string(),
    category: z.enum([
        'word_substitution',
        'addition',
        'omission',
        'major_addition',
        'full_verse_omission',
    ]),
    theologicalImpact: z.enum(['low', 'medium', 'high']),
});
/**
 * Query metadata in response.
 */
export const QueryMetadataSchema = z.object({
    detectedVerses: z.array(z.string()),
    detectedStrongsNumbers: z.array(z.string()),
    queryType: z.enum(['verse_question', 'word_study', 'topical', 'sermon_generation']),
});
/**
 * Response to a single query.
 */
export const QueryResponseSchema = z.object({
    answer: z.string(),
    citations: z.array(CitationSchema),
    variants: z.array(VariantInfoSchema).optional(),
    queryMetadata: QueryMetadataSchema,
    processingTimeMs: z.number().int().nonnegative(),
});
/**
 * Response to a chat message.
 */
export const ChatResponseSchema = z.object({
    message: z.object({
        role: z.literal('assistant'),
        content: z.string(),
    }),
    citations: z.array(CitationSchema),
    context: z.object({
        versesUsed: z.array(z.string()),
        variantsDetected: z.number().int().nonnegative(),
    }),
    processingTimeMs: z.number().int().nonnegative(),
    contextId: z.string(),
    suggestedFollowUp: z.string().optional(),
});
//# sourceMappingURL=response-types.js.map